import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageLoader from "./components/common/PageLoader";
import ScrollToTop from "./components/common/ScrollToTop";

const queryClient = new QueryClient();

const Index = lazy(() => import("./pages/Index"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Gold = lazy(() => import("./pages/collections/Gold"));
const Silver = lazy(() => import("./pages/collections/Silver"));

const CategoryProductListPage = lazy(() => import("./pages/collections/CategoryProductListPage"));
const ProductDetailPage = lazy(() => import("./pages/collections/ProductDetailPage"));
const AllProductsPage = lazy(() => import("./pages/collections/AllProductsPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const LiveRates = lazy(() => import("./pages/LiveRates"));
const NotFound = lazy(() => import("./pages/NotFound"));

import { LazyMotion, domMax } from "framer-motion";

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LazyMotion features={domMax} strict>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/collections/gold" element={<Gold />} />
              <Route path="/collections/silver" element={<Silver />} />
              <Route path="/collections/kids" element={<CategoryProductListPage />} />
              <Route path="/collections/diamond" element={<CategoryProductListPage />} />

              <Route path="/collections/all" element={<AllProductsPage />} />
              <Route path="/collections/:collectionType/:categoryName" element={<CategoryProductListPage />} />
              <Route path="/product/:slug" element={<ProductDetailPage />} />
              <Route path="/live-rates" element={<LiveRates />} />
              <Route path="/policies" element={<PrivacyPolicy />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </LazyMotion>
  </QueryClientProvider>
);

export default App;
